import React, { useEffect, useRef } from 'react';

import { useSwitch } from '../../hooks/useSwitch';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CSSTransition } from 'react-transition-group';

import './notification-bar.scss';

interface NotificationBarProps {
  text: string;
}

export const NotificationBar: React.FC<NotificationBarProps> = ({ text }) => {
  const dismissed = useSwitch();
  const ref = useRef(null);
  useEffect(() => {
    const dismissTimer = setTimeout(() => dismissed.turnOn(), 5000);
    return () => clearTimeout(dismissTimer);
  }, [dismissed]);

  return (
    <CSSTransition
      nodeRef={ref}
      classNames="fade"
      timeout={450}
      in={!dismissed.isOn}
      appear={true}
      unmountOnExit={true}
    >
      <div ref={ref} className="notification-bar">
        <span>{text}</span>
        <FontAwesomeIcon icon={light('times')} className="notification-bar--dismiss" onClick={dismissed.turnOff} />
      </div>
    </CSSTransition>
  );
};
